export const Products = {
    selectors: {
        primaryImage: '.product-gallery .primary-image',
        thumbnailOuterContainer: '.product-gallery .thumbnail-outer-container',
        thumbnailImages: '.thumbnail-image',
        owlCarousel: '.product-gallery .owl-carousel',
    },

    init: function () {
        Products.initGallery();
    },

    initGallery: function () {
        $(Products.selectors.thumbnailOuterContainer).on('click, mouseover', function () {
            $(Products.selectors.thumbnailOuterContainer).removeClass('active');
            $(this).addClass('active');
            $(Products.selectors.primaryImage).attr('src', $(this).find(Products.selectors.thumbnailImages).attr('data-large-image-url'));
        });

        $(Products.selectors.thumbnailOuterContainer).eq(0).addClass('active');

        // Owl Carousel
        const $carousel = $(Products.selectors.owlCarousel);
        if ($carousel.length > 0) {
            $carousel.owlCarousel({
                items: 1,
                responsive: false,
                lazyLoad: true
            });
        }
    }
};
